//Node Modules
import { useCallback } from "react";
import { API } from "aws-amplify";
import { useSetRecoilState, useRecoilValue } from "recoil";

//Atoms
import { dialogAtomFamily } from "../atoms/dialog";
import { selectedUserSchemeAtom } from "../atoms/user";

//Helpers
import { useLogout } from "./Auth";

export const useApiRequest = () => {
	const apiName = "andelRestApi";
	const handleLogout = useLogout();
	const setLoading = useSetRecoilState(dialogAtomFamily("loadingDialog"));
	const selectedScheme = useRecoilValue(selectedUserSchemeAtom);

	const makeRequest = useCallback(async (verb = "get", endpoint, body, message) => {
		const customInit = {
			body,
			headers: {
				"X-Scheme-Id": selectedScheme.id,
			},
		};

		try {
			message && setLoading({ visible: true, message: message });
			const response = await API[verb](apiName, endpoint, customInit);
			return response;
		} catch (err) {
			console.error("useApiRequestError:", err);
			if (err.code === "NotAuthorizedException" || err === "No current user") {
				handleLogout();
			} else if (err.response) {
				throw err;
			}
		} finally {
			message && setLoading({ visible: false, message: "" });
		}
	}, []);

	return makeRequest;
};
